import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@core/environments/environment';
import { Pagination } from '@core/models/pagination.model';
import { finalize, Observable } from 'rxjs';
import { LoadingService } from './loading.service';
import {
  ApproveUpdateResponse,
  UpdateApprovalDetailsResponse,
  UpdateApprovalListResponse,
  UpdateMetadataResponse,
} from '@core/models/admin/account/update-approvals';

@Injectable({
  providedIn: 'root',
})
export class UpdateApprovalService {
  http = inject(HttpClient);
  loadingService = inject(LoadingService);
  BASE_URL = environment.ADMIN_BASE_URL + '/v1/admin';

  constructor() {}

  getApprovalList(
    data: Pagination = new Pagination(),
    searchText?: string
  ): Observable<UpdateApprovalListResponse> {
    const uniqueStateUrl = 'get-update-approvals';
    this.loadingService.setLoading(uniqueStateUrl, true);

    let query = '';
    if (searchText) {
      query += `${searchText}`;
    } else {
      query += `take=${data.size}&skip=${data.skip}`;
    }
    return this.http
      .get<UpdateApprovalListResponse>(
        `${this.BASE_URL}/get-update-details?${query}`
      )
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }

  getUpdateApprovalDetails(
    combined_id: string
  ): Observable<UpdateApprovalDetailsResponse> {
    const uniqueStateUrl = 'get-updates-value-by-combined-id';
    this.loadingService.setLoading(uniqueStateUrl, true);

    return this.http
      .get<UpdateApprovalDetailsResponse>(
        `${this.BASE_URL}/get-updates-value-by-combined-id?combined_id=${combined_id}`
      )
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }

  processUpdate(
    combined_id: string,
    status: string
  ): Observable<ApproveUpdateResponse> {
    const uniqueStateUrl = 'approve-update';
    this.loadingService.setLoading(uniqueStateUrl, true);

    const url = status == "approved" ? `${this.BASE_URL}/approve-update` : `${this.BASE_URL}/reject-update`;

    return this.http
      .post<ApproveUpdateResponse>(url, {
        combined_id,
        status,
      })
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }

  getUpdatesMetadata(): Observable<UpdateMetadataResponse> {
    const uniqueStateUrl = 'get-update-approvals-metadata';
    this.loadingService.setLoading(uniqueStateUrl, true);

    return this.http
      .get<UpdateMetadataResponse>(`${this.BASE_URL}/get-updates-metadata`)
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }
}
